import { Component, computed, inject } from '@angular/core';
import { Store } from '@ngrx/store';

import { IAppState } from '../../../store/interface/app.state.interface';
import { IUser } from '../../../core/interfaces/user.interface';
import { IMenuItem } from '../../interfaces/layout.interface';
import { PermissionLevel } from '../../../shared/enum/permission-level.enum';
import { SIDEBAR_MENU } from '../../constant/sidebar-menu.constant';
import { holdsPermission } from '../../../shared/utils/permission.util';
import { selectLoggedInUser } from '../../../store/user/user.selectors';

@Component({
    standalone: false,
    selector: 'app-admin-sidebar',
    templateUrl: './admin-sidebar.component.html',
})
export class AdminSidebarComponent {
    private readonly store = inject(Store<IAppState>);
    private readonly loggedInUser = this.store.selectSignal(selectLoggedInUser);

    // A business without access gets an empty sidebar.
    protected readonly model = computed<IMenuItem[]>(() => {
        const user = this.loggedInUser();
        if (!user?.hasAccess) return [];
        return SIDEBAR_MENU.map((group) => ({
            ...group,
            items: this.visibleItems(group.items ?? [], user),
        }));
    });

    // Items the person may open, at any depth; a section left with no items is hidden too.
    private visibleItems(items: IMenuItem[], user: IUser): IMenuItem[] {
        return items
            .filter(
                (item) =>
                    !item.permission ||
                    holdsPermission(user, item.permission, PermissionLevel.VIEW),
            )
            .map((item) =>
                item.items ? { ...item, items: this.visibleItems(item.items, user) } : item,
            )
            .filter((item) => !item.items || item.items.length > 0);
    }
}
